import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core"
import { SlideModel } from "../../../models/student-assignment/slide.model"
import { BehaviorSubject } from "rxjs"

@Component({
    selector: "app-mobile-slides-menu",
    templateUrl: "./mobile-slides-menu.component.html",
    styleUrls: ["./mobile-slides-menu.component.scss"],
    standalone: false,
})
export class MobileSlidesMenuComponent implements OnChanges {
    @Input() public slides: SlideModel[] = []
    @Input() public selectedSlide: SlideModel
    @Input() public hasIntro: boolean = false
    @Output() public clickSlide: BehaviorSubject<SlideModel> = new BehaviorSubject<SlideModel>(null)
    @Output() public clickPrevious: EventEmitter<boolean> = new EventEmitter()
    @Output() public clickNext: EventEmitter<boolean> = new EventEmitter()
    public currentSlide: SlideModel = null
    public toggleState: boolean = false
    public slideCount: number = 0

    constructor() {}

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.slides && changes.slides.currentValue) {
            this.orderSlides()
        }
        if (changes.selectedSlide) {
            if (this.currentSlide?.id !== this.selectedSlide?.id) {
                this.selectSlide(this.selectedSlide)
                this.updateSlideCounter(this.currentSlide)
            }
        }
    }

    public orderSlides() {
        this.slides.sort((a: SlideModel, b: SlideModel) => a.order - b.order)
    }

    public selectSlide(slide: SlideModel) {
        this.currentSlide = slide
        this.unselectOtherSlides()
        this.clickSlide.next(this.currentSlide)
        // tslint:disable-next-line:no-unused-expression
        this.currentSlide && (slide.active = true)
        this.updateSlideCounter(slide)
    }

    public toggle() {
        this.toggleState = !this.toggleState
    }

    public isLastSlide() {
        if (this.currentSlide) {
            return this.currentSlide.order >= this.slides[this.slides.length - 1].order
        }
        return false
    }

    private updateSlideCounter(currentSlide) {
        this.slideCount = 0
        if (this.slides && currentSlide) {
            this.slideCount = this.slides.findIndex((slide) => slide.id === currentSlide.id) + 1
        }
    }

    private unselectOtherSlides() {
        this.slides.map((slide) => {
            slide.active = false
        })
    }
}
